<template>
	<div class="purchase_service" v-if="detail">
		<div class="purchase_service_success">
			<img
				class="purchase_service_success_icon"
				src="@/assets/icon/icon_result_success.png"
				alt
			/>
			<h2 class="purchase_service_success_title">购买成功</h2>
			<p class="purchase_service_success_desc"
				>请联系医生助手完成检测并耐心等待送检</p
			>
		</div>
		<!--检测人信息-->
		<base-card title="检测人信息" title-icon="infor.png">
			<van-cell class="form-item" title="真实姓名"
				>{{ detail.patientName }} {{ detail.patientGender }}
				{{ detail.patientAge }}岁</van-cell
			>
			<van-cell
				class="form-item"
				title="身份证号"
				>{{ detail.patientIdcard }}</van-cell
			>
		</base-card>

		<!--临床信息 -->
		<base-card
			v-if="detail.zoneType===2"
			class="mt-28"
			title="临床信息"
			title-icon="list.png"
			title-icon-width="23"
		>
			<van-field
				readonly
				class="form-item ellipsis"
				input-align="right"
				v-model="detail.diagnose"
				label="临床症状"
				placeholder="未输入临床症状"
				@click-input="clickDiagnose"
			/>
			<van-field
				readonly
				class="form-item"
				input-align="right"
				label="用药信息"
				maxlength="18"
				:value="detail.drugList&&detail.drugList.length>0?'点击查看':''"
				placeholder="未选择用药信息"
				@click-input="clickDrugInfo"
			/>
		</base-card>

		<!--检测中心-->
		<base-card
			class="mt-28"
			:title="detail.organName"
			title-icon="institution.png"
			title-icon-width="23"
		>
			<infor-card
				:list="getListDataFormat"
				:total-price="detail.totalPrice"
				:sample-type="getSampleType"
				:total-info="{
					totalNum: `共${ (detail.productList || []).length}件`,
					totalPrice: getProductTotalPrice
				}"
			></infor-card>
		</base-card>

		<export-parse :detail="detail" disabled></export-parse>

		<!--订单信息-->
		<base-card title="订单信息" class="mt-28">
			<text-item label="支付方式">微信支付</text-item>
			<text-item label="支付时间" class="mt-32">
				{{ detail.payTime }}
			</text-item>
			<text-item label="订单编号" class="mt-32">
				{{ detail.number }}
			</text-item>
			<text-item label="创建时间" class="mt-32">
				{{ detail.createTime }}
			</text-item>
		</base-card>

		<foot-button>
			<van-button type="primary" block @click="clickClose">
				关闭
			</van-button>
			<van-button
				v-if="!detail.detectInvoiceDTO"
				type="primary"
				plain
				block
				@click="clickInvoice"
			>
				开具发票
			</van-button>
		</foot-button>

		<diagnose ref="diagnose" v-model="detail.diagnose" :isView="true" />

		<drug-info
			ref="drugInfo"
			:drugList="detail.drugList"
			:otherDrugs="detail.otherDrugs"
			:isView="true"
		/>
	</div>
</template>

<script>
	import Diagnose from './components/Diagnose'
	import DrugInfo from './components/DrugInfo'
	 import ExportParse from './components/reportParse.vue'
	export default {
		name: 'PurchaseService',
		components:{ Diagnose, DrugInfo, ExportParse },
		data: () => ({
			detail: null
		}),
		created () {
			this.getDetail()
		},
		computed: {
			getListDataFormat () {
				if (!this.detail) return []
				return (this.detail.productList || []).map(item => ({
					title: item.productName,
					content: (item.itemList || []).map(val => val.itemName).join('、'),
					detectType: item.detectType,
					desc: [{ label: `￥${ item.totalPrice }`, value: `x${ item.quantity }` }]
				}))
			},
			getProductTotalPrice () {
				if (!this.detail) return 0
				return (this.detail.productList || []).reduce((v, d) => (v + d.totalPrice), 0)
			},
			getSampleType () {
				if (!this.detail) return ''
				return (this.detail.detectType || '').split('&').map(item => (this.$store.state.account.detectType[item])).join('+')
			}
		},
		methods: {
			async getDetail () {
				const res = await this.$api.order.detail(this.$route.params.id)
				if (!res.code) {
					res.data.productList = res.data.productList.map(item => ({
						...item,
						title: item.productName,
						content: (item.itemList || []).map(val => val.itemName).join('、'),
						desc: [{ label: `￥${ this.$utils.priceFilter(item.totalPrice) }`, value: `x${ item.quantity }` }]
					}))
					this.detail = res.data
				}
			},
			clickClose () {
				this.$utils.windowClose()
			},
			clickInvoice(){
				this.$router.push(`/order/invoicing/${this.detail.id}`)
			},
			clickDiagnose(){
				if(!this.detail.diagnose)return
				this.$refs.diagnose.show=true
			},
			clickDrugInfo(){
				if(!this.detail.drugList)return
				this.$refs.drugInfo.init()
			}
		}
	}
</script>

<style scoped lang="less">
	.purchase_service {
		padding: 32px;
		&_success {
			padding: 42px 0;
			text-align: center;
			&_icon {
				width: 110px;
				height: 110px;
				vertical-align: middle;
			}
			&_title {
				font-family: PingFangSC-Medium;
				font-size: 42px;
				font-weight: normal;
				line-height: 50px;
				color: #333333;
				margin-top: 32px;
			}
			&_desc {
				margin-top: 16px;
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: #646a73;
			}
		}
	}
</style>

<style lang="less">
	.purchase_service {
		.van-cell__title {
			flex: 0 0 160px;
		}
		.van-cell__value {
			flex: auto;
			text-overflow: ellipsis;
			.van-field__body{
				.van-field__control--right{
					text-overflow: ellipsis;
				}
			}
		}
	}
</style>
